module.exports = __webpack_public_path__ + "static/media/cordova-splash-screen.99bfc3.png";